if (window.WEBPACK_CDN_PUBLIC_PATH) {
  __webpack_public_path__ = WEBPACK_CDN_PUBLIC_PATH; //eslint-disable-line
}
